import { Button } from "@/components/ui/buttons/button";

interface ArenaCardProps {
  isDuelActive: boolean;
  isDuelWaiting: boolean;
  isInitializingDuel: boolean;
  handleReconnectToDuel: () => void;
  handleStartDuel: () => void;
}

export const ArenaCard = ({
  isDuelActive,
  isDuelWaiting,
  isInitializingDuel,
  handleReconnectToDuel,
  handleStartDuel,
}: ArenaCardProps) => {
  return (
    <Button
      onClick={isDuelActive ? handleReconnectToDuel : handleStartDuel}
      disabled={isInitializingDuel || isDuelWaiting}
      variant={isDuelWaiting ? "red" : isDuelActive ? "red" : "night"}
      className="w-full"
    >
      <div
        className={`rounded-xl p-[4px] shadow-xl transition-colors duration-300 animate-slide-left-fade opacity-0`}
        style={{ animationDelay: "0ms" }}
      >
        <div
          className={`relative h-14 xs:h-24 px-4 xs:px-8 gap-4 xs:gap-8 rounded-md overflow-hidden flex items-center justify-between ${
            isDuelActive ? "animate-pulse" : ""
          }`}
        >
          {/* Animated Shine */}
          <div
            className={`absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-300 ease-in-out ${
              isDuelActive ? "animate-pulse" : ""
            }`}
          />

          <div className="z-10 relative flex flex-col items-start gap-1">
            <span className="drop-shadow-[3px_3px_0_rgba(0,0,0,0.8)] font-black text-white text-lg xs:text-3xl italic tracking-wider">
              {isDuelWaiting
                ? "IN QUEUE..."
                : isDuelActive
                ? "RECONNECT"
                : "ARENA"}
            </span>
            <div className="flex items-center gap-2">
              <span className="bg-pk-garnet-1 px-2 py-0.5 rounded-sm font-bold text-[10px] text-white uppercase tracking-wider">
                PvP
              </span>
              <span className="font-bold text-pk-gray-4 text-xs xs:text-sm uppercase tracking-widest">
                {isDuelWaiting
                  ? "Waiting..."
                  : isDuelActive
                  ? "Battle Active"
                  : "Ranked Battles"}
              </span>
            </div>
          </div>

          <img
            src="/assets/icons/medal.png"
            alt="Arena"
            className="w-10 xs:w-16 h-10 xs:h-16 object-contain"
          />
        </div>
      </div>
    </Button>
  );
};
